import { render, staticRenderFns } from "./BaseDatepicker.vue?vue&type=template&id=48e39546&scoped=true&"
import script from "./BaseDatepicker.vue?vue&type=script&lang=js&"
export * from "./BaseDatepicker.vue?vue&type=script&lang=js&"
import style0 from "./BaseDatepicker.vue?vue&type=style&index=0&id=48e39546&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e39546",
  null
  
)

export default component.exports